import { darken, styled } from "@mui/system"

export const UiPageTitle = styled("h1", {
  name: "PageTitle",
})(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: 1.2,
}))

export const UiSubTitle = styled("p", {
  name: "SubTitile",
})(({ theme, color }) => ({
  color: color === "primary" ? theme.palette.text.primary : theme.palette.text.secondary,
  fontSize: "15px",
  fontWeight: 400,
}))

export const UiSectionTitle = styled("h3", {
  name: "SectionTitle",
})(({ theme, fontSize, fontWeight }) => ({
  marginBottom: 0,
  color: theme.palette.text.primary,
  fontSize: fontSize ? fontSize : "18px",
  fontWeight: fontWeight ? fontWeight : 700,
  fontStyle: "normal",
  lineHeight: "normal",
}))

export const UiTextWrapper = styled("span", {
  name: "Text",
})(({ theme, size, weight, color }) => ({
  fontSize: `${size || 16}px`,
  fontWeight: weight || 400,
  color: theme.palette.text[`${color || "primary"}`],
  ...(color === "theme"
    ? {
        color: theme.palette.primary.main,
      }
    : color === "inherit"
      ? {
          color: "inherit",
        }
      : {}),
}))

export const UiChatLabel = styled("p", {
  name: "ChatLabel",
})(({ theme }) => ({
  color: theme.palette.text.tertiary,
}))

export const UiChatMessage = styled("p", {
  name: "ChatMessage",
})(({ theme }) => ({
  color: theme.palette.text.tertiary,
}))

export const UiFieldErrorText = styled("p", {
  name: "FieldErrorText",
})(({ theme }) => ({
  background: darken("#F50004", 0.8),
  color: theme.palette.text.primary,
  padding: "10px",
}))
